import script from "./UserAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAdd.vue?vue&type=script&setup=true&lang=js"

import "./UserAdd.vue?vue&type=style&index=0&id=914e979c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-914e979c"]])

export default __exports__